import styled, { keyframes } from 'styled-components';

import { rem } from '../../shared/style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';

// the -12px below is not a relative unit
// because the animation breaks in IE11
// when used within react-modal
const bounceAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-12px);
  }
  60% {
    transform: translateY(0);
  }
`;

export const BouncerWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
`;

type BouncerDotProps = {
  light?: boolean;
};

export const BouncerDotStyled = styled.div<BouncerDotProps>`
  width: ${rem(16)};
  height: ${rem(16)};
  background: ${({ light }) => (light ? grey1 : grey5)};
  border-radius: 50%;
  margin: 0 ${rem(6)};
  animation: ${bounceAnimation} 1.2s ease-in-out infinite;
  &:nth-of-type(2) {
    animation-delay: 0.3s;
  }
  &:nth-of-type(3) {
    animation-delay: 0.6s;
  }
`;

export const VisuallyHiddenText = styled.p`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
